var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUpreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6431 15.984C18.412 15.9472 18.1965 15.8476 18.0277 15.6956L11.998 10.4764L5.96238 15.7015C5.75002 15.8906 5.45749 15.9975 5.15433 15.9975C4.69409 15.9974 4.27265 15.7517 4.0907 15.3639C3.90227 14.9623 4.0141 14.5003 4.36429 14.2052L11.197 8.2901C11.644 7.90331 12.3528 7.90331 12.7997 8.29004L19.6372 14.2092C19.9872 14.5005 20.1 14.9697 19.9049 15.3751C19.7167 15.7663 19.2847 16.0092 18.819 15.9997L18.6431 15.984Z",
    fill: "currentColor"
  })));
}
export default SvgChevronUpreact;